

























import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api from "../../../components/http/api";
import { RegisterInfo } from "../user/UserApi";
import { CouponRequestInfo } from "./CouponApi";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
  },
})
export default class GetCoupon extends mixins(WeMixin) {
  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private couponRequestInfo: CouponRequestInfo = {} as CouponRequestInfo;
  private rTime: number = 0;

  private buttonShow: boolean = false;
  private buttonActive: boolean = false;

  protected created() {
    this.getCustomerInfo();
  }

  protected getCustomerInfo() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.flag === "0") {
        this.registerInfo = res.data;
        if (this.registerInfo.phone === this.$route.params.phone) {
          this.buttonShow = true;
        } else {
          this.$toast("注册手机号与企微登记手机号不一致，请联系工作人员");
        }
      } else if (res.data.flag === "1") {
        this.registerInfo = res.data;
        const interval = window.setInterval(() => {
          if (--this.rTime <= 0) {
            window.clearInterval(interval);
            this.$router.replace(
              "/main/user/registerFromCoupon/" +
                this.$route.params.orgid +
                "&" +
                this.$route.params.phone +
                "&" +
                this.$route.params.activityid +
                "&" +
                this.$route.params.randomid +
                "&" +
                this.$route.params.sysUserId.replace(/\//g, "%2F") +
                "&" +
                this.$route.params.sysUserPhone
            );
          }
        }, 2000);
      }
    });
  }

  protected getCoupon() {
    this.couponRequestInfo.openid = this.registerInfo.openid;
    this.couponRequestInfo.phone = this.$route.params.phone;
    this.couponRequestInfo.activityid = this.$route.params.activityid;
    this.couponRequestInfo.orgid = this.$route.params.orgid;
    this.couponRequestInfo.randomid = this.$route.params.randomid;
    this.couponRequestInfo.sysUserId = this.$route.params.sysUserId;
    this.couponRequestInfo.sysUserPhone = this.$route.params.sysUserPhone;
    this.buttonActive = true;
    api
      .post("/weixinmp/xsyx/coupon/getActivityInfo", this.couponRequestInfo)
      .then((res: any) => {
        if (res.data.owner === "1") {
          // 498供应商
          window.location.href =
            process.env.VUE_APP_498_URL +
            encodeURIComponent(
              // "https://www.tongdatech.com:443/xsyx" +
              process.env.VUE_APP_URLFRONT +
                "/main/coupon/getCouponResult498?a=" +
                this.$route.params.orgid +
                "&b=" +
                this.$route.params.phone +
                "&c=" +
                this.$route.params.activityid +
                "&d=" +
                this.$route.params.randomid +
                "&e=" +
                this.$route.params.sysUserId.replace(/\//g, "%2F") +
                "&f=" +
                this.registerInfo.openid +
                "&g=" +
                this.$route.params.sysUserPhone
            );
        } else if (res.data.owner === "null") {
          this.$toast("该活动不存在，请联系工作人员");
        } else {
          this.$router.push(
            "/main/coupon/getCouponResult/" +
              this.$route.params.orgid +
              "&" +
              this.$route.params.phone +
              "&" +
              this.$route.params.activityid +
              "&" +
              this.$route.params.randomid +
              "&" +
              this.$route.params.sysUserId.replace(/\//g, "%2F") +
              "&" +
              this.registerInfo.openid +
              "&" +
              this.$route.params.sysUserPhone
          );
        }
      });
  }
}
